.underlineText {
  display: inline-block;
  text-decoration: underline dashed;
  text-underline-offset: 6px;
  text-decoration-thickness: 1px;
  text-decoration-color: var(--border-default);
}
